/**
 * Tab Reviews: de bestaande reviewgegevens van deze klant
 * (`GET /api/klanten/{id}/reviews`, tabel review_raw op klant_id), nieuwste
 * eerst; zonder gekoppelde review "Geen reviews". Zelfde cache als het
 * reviewblok van de pagina Klanten. Sessie 141-E: in de kop rechts het
 * gemiddelde op vijf ("gemiddeld 4,8 van 5", dezelfde schaal als de regels); het aantal staat op de
 * tabteller.
 */
import { useQuery } from "@tanstack/react-query";

import { klantenApi } from "@/lib/api";

import { reviewsSleutel, scoreWoord } from "../../Klanten/kaart/hulp";
import { dagDatum, gemiddeldOpVijf } from "./hulp";

const BRON: Record<string, string> = {
  google: "Google",
  webwinkelkeur: "WebwinkelKeur",
  overig: "Overig",
};

export function TabReviews({ klantId }: { klantId: string }) {
  const q = useQuery({
    queryKey: reviewsSleutel(klantId),
    queryFn: () => klantenApi.reviews(klantId),
    staleTime: 5 * 60_000,
  });
  if (q.isLoading) return <p className="stil">Reviews worden geladen.</p>;
  if (q.isError)
    return (
      <p className="v6-fout" role="alert">
        De reviews konden niet geladen worden.
      </p>
    );
  const lijst = q.data ?? [];
  if (lijst.length === 0) {
    return (
      <div className="kk10-blok">
        <div className="bb">
          <span className="vol stil">Geen reviews.</span>
        </div>
      </div>
    );
  }
  const gemiddeld = gemiddeldOpVijf(lijst);
  return (
    <div className="kk10-blok" data-testid="reviews">
      <div className="bh">
        Reviews
        {gemiddeld ? (
          <span className="r" data-testid="reviews-gemiddeld">{`gemiddeld ${gemiddeld} van 5`}</span>
        ) : null}
      </div>
      <ul className="kk10-lijstje vast">
        {lijst.map((r) => (
          <li key={r.id} className="review">
            <span className="d num">{dagDatum(r.review_created_at)}</span>
            <span className="w">
              <b>{scoreWoord(r.review_score, r.score_max) ?? "geen score"}</b>
              {r.review_text ? ` · "${r.review_text}"` : ""}
              <small className="kk10-bron">
                {` ${BRON[r.bron] ?? r.bron}, ${r.beantwoord ? "beantwoord" : "onbeantwoord"}`}
              </small>
            </span>
            <span />
          </li>
        ))}
      </ul>
    </div>
  );
}
